import SearchIcon from '@mui/icons-material/Search';
import BarcodeScannerIcon from '@mui/icons-material/ViewWeek';
import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ScannerModal from '../../redux/containers/scanner/ScannerModal';
import StoreSelector from '../../redux/containers/store/StoreSelector';
import { COLORS } from '../tasks/constants';

const styles = {
  root: {
    mb: 2,
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  storeWrapper: {
    minWidth: 0,
    flexShrink: 1,
    overflow: 'hidden',
  },
  actionsWrapper: {
    display: 'flex',
    gap: 1.5,
    flexShrink: 0,
  },
  searchBtn: {
    bgcolor: '#1a1a1a',
    color: '#fff',
    px: 2,
    '&:hover': { bgcolor: '#333' },
  },
  scanBtn: {
    bgcolor: COLORS.SCANNER,
    color: '#fff',
    py: 0.8,
    px: 2,
    '&:hover': { bgcolor: COLORS.SCANNER_HOVER },
  },
};

export default function ActionBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [scannerOpen, setScannerOpen] = useState(false);

  return (
    <>
      <Box sx={styles.root}>
        <Box sx={styles.storeWrapper}>
          <StoreSelector />
        </Box>
        <Box sx={styles.actionsWrapper}>
          <Button
            variant="contained"
            size="small"
            startIcon={<SearchIcon />}
            onClick={() => navigate('/products')}
            sx={styles.searchBtn}
          >
            {t('bruno.buttons.search', 'Search')}
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<BarcodeScannerIcon />}
            onClick={() => setScannerOpen(true)}
            sx={styles.scanBtn}
          >
            {t('bruno.products.scan', 'Scan')}
          </Button>
        </Box>
      </Box>
      <ScannerModal open={scannerOpen} onClose={() => setScannerOpen(false)} />
    </>
  );
}
